import { CheckCircleIcon } from '@heroicons/react/outline';
import useLocale from 'next-translate/useTranslation';

import clsxm from '@/lib/clsxm';

import {
  useMediaSelection,
  useMediaSelectionActive,
} from './MediaSelectionProvider';

const toolbarButtonClassName =
  'inline-flex items-center gap-1.5 rounded-lg px-2.5 py-2 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 disabled:cursor-not-allowed disabled:opacity-50';

/** Enters selection mode (or leaves it). Lives next to the view-mode menu. */
export const MediaSelectButton = ({ className }: { className?: string }) => {
  const { t } = useLocale('media-library');
  const context = useMediaSelection();
  const active = useMediaSelectionActive();
  if (!context || context.alwaysSelecting) return null;

  return (
    <button
      type='button'
      aria-pressed={active}
      onClick={() =>
        active ? context.actions.clear() : context.actions.enterSelectionMode()
      }
      className={clsxm(
        toolbarButtonClassName,
        active
          ? 'bg-gray-900 text-white hover:bg-gray-800 dark:bg-white dark:text-gray-900 dark:hover:bg-gray-100'
          : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white',
        className,
      )}
    >
      <CheckCircleIcon className='h-5 w-5' aria-hidden='true' />
      <span>{active ? t('Done') : t('Select')}</span>
    </button>
  );
};
